module.exports = __webpack_public_path__ + "static/media/ic_text_selected_inverted.1da422c7.svg";